import { Producto } from "./producto";

export class Item {
    id: number;
    producto: Producto;
    precio: number;
    cantidad: number;

    constructor(producto: Producto, cantidad: number = 1) {
        this.cantidad = cantidad;
        this.producto = producto;
        this.precio = producto.precio;
    };

    total(): number {
        return this.producto.precio * this.cantidad;
    }
}